var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-name":"PositionPageMenu"}},[_c('EmployeeHorizontalMenu',{key:_vm.menuKey,attrs:{"menuItems":_vm.computedMenuItems,"initialTab":_vm.activeTab},on:{"tab-selected":_vm.handleTabSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }